const API_BASE = process.env.VUE_APP_BASEURL;

const emptyGiftCardPurchase = () => ({
  giftCard: null,
  customer: {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    country: 'Mexico',
    state: '',
    language: 'es',
  },
  quote: null,
  order: null,
  payment: null,
  confirmation: null,
  recipient_name: '',
  recipient_email: '',
  message: '',
});

const state = {
  purchase: emptyGiftCardPurchase(),
  giftCard: null,
};

const getters = {
  getPassportGiftCardPurchase(state) {
    return state.purchase;
  },
  getPassportGiftCard(state) {
    return state.giftCard;
  },
};

const mutations = {
  SET_GIFT_CARD(state, giftCard) {
    state.giftCard = giftCard || null;
    state.purchase.giftCard = giftCard || null;
  },
  SET_PURCHASE(state, payload) {
    state.purchase = { ...state.purchase, ...payload };
  },
  SET_CUSTOMER(state, payload) {
    state.purchase.customer = { ...state.purchase.customer, ...payload };
  },
  CLEAR_PURCHASE(state) {
    state.purchase = emptyGiftCardPurchase();
  },
};

const jsonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

async function parseResponse(res) {
  const json = await res.json();
  if (!res.ok) return json;
  return json;
}

const actions = {
  clearPassportGiftCardPurchase({ commit }) {
    commit('CLEAR_PURCHASE');
  },
  updatePassportGiftCardPurchase({ commit }, payload) {
    commit('SET_PURCHASE', payload);
  },
  updatePassportGiftCardCustomer({ commit }, payload) {
    commit('SET_CUSTOMER', payload);
  },
  async getPassportGiftCard({ commit }, id) {
    const res = await fetch(`${API_BASE}public/passports/gift-cards/${id}`, {
      method: 'GET',
      headers: jsonHeaders,
    });
    const response = await parseResponse(res);
    if (response.data) commit('SET_GIFT_CARD', response.data);
    return response;
  },
  async quotePassportGiftCard({ commit }, payload) {
    const res = await fetch(`${API_BASE}public/passports/gift-cards/${payload.gift_card_id}/quote`, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify({}),
    });
    const response = await parseResponse(res);
    if (response.data) commit('SET_PURCHASE', { quote: response.data });
    return response;
  },
  async savePassportGiftCardCustomer({ commit }, payload) {
    const res = await fetch(`${API_BASE}public/passports/customers`, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(payload),
    });
    const response = await parseResponse(res);
    if (response.data) commit('SET_CUSTOMER', response.data);
    return response;
  },
  async createPassportGiftCardOrder({ commit }, payload) {
    const res = await fetch(`${API_BASE}public/passports/gift-cards/${payload.gift_card_id}/orders`, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(payload),
    });
    const response = await parseResponse(res);
    if (response.data) commit('SET_PURCHASE', { order: response.data });
    return response;
  },
  async createPassportGiftCardPaymentIntent({ commit }, payload) {
    const res = await fetch(`${API_BASE}public/passports/gift-cards/payment-intent`, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(payload),
    });
    const response = await parseResponse(res);
    if (response.data) commit('SET_PURCHASE', { payment: response.data });
    return response;
  },
  async confirmPassportGiftCardPurchase({ commit }, payload) {
    const res = await fetch(`${API_BASE}public/passports/gift-cards/confirm`, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(payload),
    });
    const response = await parseResponse(res);
    if (response.data) commit('SET_PURCHASE', { confirmation: response.data });
    return response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
